import { ArrowRight, Sparkles } from 'lucide-react';
import './CTA.css';

export default function CTA() {
    return (
        <section className="cta">
            <div className="cta__container">
                <div className="cta__glow" aria-hidden="true" />

                <div className="cta__content">
                    <div className="cta__badge">
                        <Sparkles className="cta__badgeIcon" aria-hidden="true" />
                        <span>Limited Time Offer</span>
                    </div>

                    <h2 className="cta__title">
                        Ready to transform your
                        <br />
                        architectural workflow?
                    </h2>

                    <p className="cta__subtitle">
                        Join thousands of architects who are already designing smarter with Revitrone.
                        Start your free trial today — no credit card required.
                    </p>

                    <div className="cta__buttons">
                        <button className="cta__primary" type="button">
                            Start Free Trial
                            <ArrowRight className="cta__btnIcon" aria-hidden="true" />
                        </button>
                        <button className="cta__secondary" type="button">
                            Schedule Demo
                        </button>
                    </div>

                    <p className="cta__note">
                        ✓ 14-day free trial &nbsp;&nbsp; ✓ No credit card required &nbsp;&nbsp; ✓ Cancel anytime
                    </p>
                </div>
            </div>
        </section>
    );
}
